import "invokers-polyfill";

// Polyfills `Math.clamp`
if (typeof Math.clamp !== "function") {
  Math.clamp = function(x, lower, upper) {
    return Math.min(Math.max(x, lower), upper);
  }
}

/**
 * Shortcut
 * @param {string} condition 
 * @param {Function} fallback 
 */
function polyfill(condition, fallback) {
  if (!CSS.supports(condition)) {
    fallback();
  }
}